/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
import { Card, CardHeader, Table, Container, Row } from 'reactstrap';
import { GlobalContext } from '../api/GlobalContext';
import { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// core components
import Header from 'components/Headers/Header';

const Patients = () => {
  const navigate = useNavigate();

  // Get our Globals
  const { apiClient } = useContext(GlobalContext);

  // Update the user patients and conversations the first time this component loads
  const [rsp, setRsp] = useState({ Status: 'Loading...' });

  useEffect(() => {
    // Go get the conversations for this user
    apiClient
      .getAffiliateResponse()
      .then((data) => {
        setRsp(data);
      })
      .catch((error) => {
        setRsp({ error: error });
      });
  }, [apiClient]);

  return (
    <>
      <Header isLite={true} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Affiliate Dashboard</h3>
              </CardHeader>
              <pre>{JSON.stringify(rsp, null, 2)}</pre>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Patients;
